var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APP_ROUTES, useAppNavigate } from '@core';
import { DESIGNING_ROUTES } from '@features/home/constants';
import { LandingSections } from '@features/landing/constants';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AboutUsComponent } from './about-us.component';
import { Contacts } from './contacts.component';
import { FAQ } from './faq.component';
import { Footer } from './footer.component';
import { HowOurServiceWorks } from './how-our-service-works.component';
import { PageTop } from './page-top.component';
import { SubSelect } from './sub-select';
var LandingPage = function () {
    var pageContentWrapperRef = useRef(null);
    var _a = useSearchParams(), search = _a[0], setSearch = _a[1];
    var navigate = useAppNavigate();
    var sectionId = search.get('sectionId');
    useEffect(function () {
        var _a, _b;
        if (sectionId === LandingSections.designing.id) {
            setSearch({});
            navigate("".concat(APP_ROUTES.designing.route, "/").concat(DESIGNING_ROUTES.main.route));
        }
        else
            (_b = (_a = pageContentWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("#".concat(sectionId))) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth' });
    }, [sectionId]);
    return (_jsxs("div", __assign({ ref: pageContentWrapperRef, className: "flex w-full flex-col items-center overflow-x-hidden pt-[23px]" }, { children: [_jsx(PageTop, {}), _jsx(AboutUsComponent, {}), _jsx(HowOurServiceWorks, {}), _jsx(SubSelect, {}), _jsx(FAQ, {}), _jsx(Contacts, {}), _jsx(Footer, {})] })));
};
export default LandingPage;
